import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavbarMessageService {
  private message =  new BehaviorSubject<string>('');
  readonly message$ = this.message.asObservable();

  clearMessage() {
    this.message.next('');
  }

  getMessage() {
    return this.message.asObservable();
  }

  setMessage(panalSize: string) {
    this.message.next( panalSize );
  }
}
